import { AutoSave } from '@equifinance/shared';
import AccountTabPage from '../Page/AccountTabPage';
import { ApplicationPageType } from '../AccountTabNav';
import ProductSidebarFooter from '../Products/ProductSidebar/ProductSidebarFooter';
import AccountStage from '../AccountStage';
import { useCreditAutoSave, useCreditContext } from '../../contexts/credit';
import CreditForm from './CreditForm';
import CreditSidebar from './CreditSidebar';

export default function CreditPage() {
  const { credit } = useCreditContext();

  return (
    <AccountTabPage
      subHeader={<AccountStage />}
      sidebar={<CreditSidebar />}
      sidebarFooter={<ProductSidebarFooter />}
      page={ApplicationPageType.CREDIT}
    >
      {credit && (
        <AutoSave autoSave={useCreditAutoSave}>
          <CreditForm />
        </AutoSave>
      )}
    </AccountTabPage>
  );
}
